import { useEffect } from "react";
import {
  useGetAllCurrenciesQuery,
  useLazyGetCurrencyByIdQuery,
} from "../../Store/Services/CurrencyService";

const CurrencyInitializer = () => {
  const { data: currencies } = useGetAllCurrenciesQuery();
  const [getCurrencyById] = useLazyGetCurrencyByIdQuery();

  useEffect(() => {
    const initializeCurrency = async () => {
      // Already initialized
      if (sessionStorage.getItem("currencyId")) {
        return;
      }

      if (!currencies?.length) {
        return;
      }

      try {
        const defaultCurrencyId = currencies[0].curId;

        const currency = await getCurrencyById(defaultCurrencyId).unwrap();

        sessionStorage.setItem("currencyId", currency.curId);
        sessionStorage.setItem("currencyName", currency.curName);
        sessionStorage.setItem("currencySymbol", currency.curSymbol);
        sessionStorage.setItem("currencyRate", currency.rate);
      } catch (err) {
        console.error("Unable to initialize currency", err);
      }
    };

    initializeCurrency();
  }, [currencies, getCurrencyById]);

  return null;
};

export default CurrencyInitializer;